import RA from 'ra-config'
import request from '../request'

const ROOT = RA.app.factors.dataFolder

export function getFactors() {
  return request(`${ROOT}/FACTOR_AGG.json`)
}

export function getFactorSeries(id) {
  return request(`${ROOT}/FACTOR_SERIES_${id}.json`, {
    initial: id
  })
}



// WEBPACK FOOTER //
// ./src/actions/factors.js